/**
 * DangerButton — 危险操作按钮
 * Fluent UI v9 Button 没有 danger 变体，用 inline style 实现
 */
import type { ReactNode } from 'react'
import { Button, Spinner } from '@fluentui/react-components'

interface DangerButtonProps {
  loading?: boolean
  disabled?: boolean
  onClick?: () => void
  children?: ReactNode
}

export default function DangerButton({
  loading = false,
  disabled,
  onClick,
  children,
}: DangerButtonProps) {
  return (
    <Button
      as="button"
      appearance="primary"
      style={{
        backgroundColor: '#d13438',
        borderColor: '#d13438',
        color: '#ffffff',
      }}
      disabled={disabled || loading}
      icon={loading ? <Spinner size="tiny" /> : undefined}
      onClick={onClick}
    >
      {children}
    </Button>
  )
}
